<template>
  <div class="wrapper">
    <!-- <i-search v-if="list"></i-search> -->
    <!-- <div class="banner">
      <i-banner :list="imgList"
                :height="4.21"></i-banner>
    </div> -->

    <div class="container"
         v-if="list">
      <div>
        <menuBar :type="'video'" @menuBar="menuBar"></menuBar>
        <div v-show="false" class="title_type">
          <div @click="toMore('new')">
            <span>更多</span>
            <img src="../../assets/images/more.png"
                 alt="">
          </div>
        </div>

        <div v-show="showAll" class="searchWrap">
          <i-search ref="search" v-on:search="searchHandle"></i-search>
        </div>

        <i-videolist :video_newest="vidoList"
                     v-on:success="success"></i-videolist>
        <!-- <div class="title_type">
				<span>最热</span><div @click="toMore('hot')"><span>更多</span><img src="../../assets/images/more.png" alt=""></div>
        </div>-->
        <!-- <i-videolist :video_newest="video_hottest" v-on:success="success"></i-videolist> -->
      </div>
    </div>

    <!-- <filterBnt @filterBnt="filter"></filterBnt>
    <filterResult @reset="filterResultReset"
                  @sure="filterResultSure"
                  v-show="filterResultVib"></filterResult> -->
  </div>
</template>
<style scoped lang="scss">
.wrapper {
  height: 100%;
  overflow: hidden;
}

.banner {
  /*width: 6.9rem;*/
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  width: 100%;
  /*margin: 0.21rem auto 0.4rem;*/
  .swiper-container {
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.container {
  padding: 0 0.3rem;
  box-sizing: border-box;
  margin-bottom: 1.18rem;
  // margin-top: 0.2rem;
}

.title_type {
  display: flex;
  align-items: center;
  height: 0.35rem;
  margin-top: 0.1rem;

  justify-content: flex-end;
  margin-bottom: 0.2rem;

  div {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-size: 0.24rem;
      color: #1b94f5;
    }
  }

  > span:nth-of-type(1) {
    color: #1b94f5;
    font-size: 0.36rem;
    font-weight: bold;
  }

  img {
    width: 0.25rem;
    height: 0.25rem;
    margin-left: 0.07rem;
  }
}
</style>

<script>
import iBanner from "../container/banner";
import iVideolist from "../container/videoList";
import iSearch from "../container/search";
import filterBnt from "../container/filterBnt";
import menuBar from "../container/menu";
import filterResult from "../container/filterResult";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  components: {
    iBanner,
    iVideolist,
    iSearch,
    filterBnt,
    menuBar,
    filterResult,

  },
  props: {},
  data() {
    return {
      isShow: false,
      imgList: [],
      list: null,
      vidoList: [],

      video_all: [],

      video_newest: [],
      video_hottest: [],
      video_recommend: [],
      title: "",
      type: "",
      allList: [],
      ra_wxUser: null,

      filterResultVib: false,


      reachBottom: true,

      showAll: true,

      page: 1,
      size: 12,
      total: 0,
      isEnd: false,
      isAllowLoading: true,

      searchParams: {},
    };
  },

  created() {
    this.$waiting.show(3);
  },
  async mounted() {
    this. ra_wxUser=await loginService.getLoginUser();

    setTimeout(() => {
      document.title = "视频";
    }, 200);
    // window.addEventListener(
    //   "popstate",
    //   function (e) {
    //     document.title = "视频";
    //     let mask = document.querySelectorAll(".weui-mask")[0];
    //     let dialog = document.querySelectorAll(".weui-dialog")[0];
    //     // // console.log(ss);
    //     mask.className += " weui-animate-fade-out";
    //     dialog.className += " weui-animate-fade-out";
    //     // location.reload()
    //     document.title = "视频";
    //   },
    //   false
    // );
    // document.title = "视频";
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.getAllList();
    this.getList();
  },

  methods: {
    filter() {
      this.filterResultVib = true;
    },
    filterResultReset() {
      this.filterResultVib = false;
    },
    filterResultSure(res) {
      console.log(res);
      let params = {
        title: "",
        type: "",
        order: res.egId,
        ccId: res.ccId,
        lId: res.level
      };
      sessionStorage.setItem("ra_more", JSON.stringify(params));
      this.$router.push({
        name: "Allvideo",
        query: params
      });
    },
    menuBar(val) {
      this.showAll = false;
      if (val === 0) {
        this.showAll = true;
        this.vidoList = this.video_all;
      } else if (val == 1) {
        this.vidoList = this.video_newest;
      } else if (val == 2) {
        this.vidoList = this.video_hottest;
      } else if (val == 3) {
        this.vidoList = this.video_recommend;
      }
    },
    toMore(type) {
      let uid = ''
      if (this.ra_wxUser && this.ra_wxUser.uId) {
        uid = this.ra_wxUser.uId
      }
      let params = {
        title: "",
        type: "",
        order: type,
        buy_uid: uid
      };
      sessionStorage.setItem("ra_more", JSON.stringify(params));
      this.$router.push({
        name: "Allvideo",

      });
    },
    getList() {
      this.$postHttp(AppSetting.baseUrl + "/video/list", {
        uid: this.ra_wxUser ? this.ra_wxUser.uId : "",
        proid: 1
      }).then(res => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;
          //this.vidoList = data.video_newest;
          this.video_newest = data.video_newest;
          this.imgList = data.pictures.filter(v => v.pSysType == '1');
          this.video_hottest = data.video_hottest;
          this.video_recommend = data.video_recommend;
        }
      });
    },

    none() {
      this.isShow = false;
    },
    screenOut() {
      this.isShow = !this.isShow;
    },


    getAllList(page = 1, params = {}) {
      this.isAllowLoading = false;
      this.page = page;
      this.$waiting.show(3);
      let query = this.$route.query;
      //let more = JSON.parse(sessionStorage.getItem("ra_more"));
      let p = {
        title: '',
        type: '',
        order: '',
        page: page,
        size: this.size
      };

      p = {...p, ...params}

      p = Object.assign(p, query);
      // sessionStorage.setItem('ra_search',JSON.stringify(params));
      this.$postHttp(AppSetting.baseUrl + "/video/list/condition", p).then(
          res => {
            // console.log(res);
            if (res.data.code == 0) {
              let data = res.data.list;
              let total = res.data.total;

              this.isEnd = page * this.row >= total

              this.data = data.length == 0;

              this.vidoList = page == 1 ? data : this.vidoList.concat(data);
              this.video_all = this.vidoList;

              this.$waiting.hide();

              this.isAllowLoading = true;
            }
          }
      );
    },

    onReachBottom() {
      console.log('onReachBottom')
      this.showAll && this.isAllowLoading && !this.isEnd && this.getAllList(this.page + 1, this.searchParams);
    },

    searchHandle(params) {
      this.searchParams = params;
      this.getAllList(1, params)
    },
  },
  activated() {

    if (this.$route.meta.keepAliveChange) {
      //this.getList();
    }

  },
  computed: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/video/index.vue